import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import { isMobile } from '@quiqupltd/qu-react-sdk/lib/utils/browser';
import { Container, Header, LottieContainer, Content, Icon, DriverContainer } from './styles';
import * as orderArrivedData from './../../../../animations/orderarrived.json';
import DriverCard from './../../driver-card/DriverCard';
import { customizationsPropTypes } from '../../../../utils/prop-types';

export default class ArrivedCardBody extends PureComponent {
  static propTypes = {
    onToggleOpenCard: PropTypes.func.isRequired,
    quiqee: PropTypes.objectOf(PropTypes.string).isRequired,
    customizations: customizationsPropTypes,
  };

  static defaultProps = {
    customizations: {},
  };

  render() {
    const { onToggleOpenCard, quiqee, customizations } = this.props;
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: orderArrivedData,
    };

    return (
      <Container onClick={onToggleOpenCard}>
        {isMobile() && <Icon icon="chevron-down" width={20} height={20} />}

        <LottieContainer>
          <Lottie options={defaultOptions} height={400} width={400} />
        </LottieContainer>

        <Header>Your driver has arrived</Header>
        <Content>They should be just outside</Content>

        <DriverContainer>
          <DriverCard quiqee={quiqee} showPhone={!customizations.hideCourierNumber} />
        </DriverContainer>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/order-card/arrived/body/ArrivedCardBody.js